<template>
    <b-form-input v-model="currentUserInput" :disabled="disabled" :state="state" @blur="parseUserInput" @keyup.native="formatUserInputInline" placeholder="hh:mm:ss">

    </b-form-input>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';

    import DateTimeMixin from '../mixins/DateTimeMixin';
    import ErrorsMixin from '../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);
    export default {
        name: 'AudioLengthInput',
        mixins: [DateTimeMixin,ErrorsMixin],
        model: {
            event: 'change',
            prop: 'seconds'
        },
        props: {
            seconds: {
                type: Number,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            state: {
                type: Boolean,
                default: null
            }
        },
        data() {
            return {
                currentSeconds: this.seconds,
                currentUserInput: null
            }
        },
        watch: {
            seconds() {
                this.currentSeconds = this.seconds;
                this.formatSeconds();
            }
        },
        methods: {
            formatSeconds() {
                if (this.currentSeconds == null) {
                    this.currentUserInput = null;
                } else {
                    this.currentUserInput = this.formatSecondsAsDuration(this.currentSeconds);
                }
            },
            formatUserInputInline(event) {
                var digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
                if (event.key && digits.includes(event.key)) {
                    var userInput = this.currentUserInput;
                    if (userInput != null) {
                        var re = new RegExp("^ *([0-9]{1,2}:)?[0-9]{3,3}$");
                        if (re.test(userInput)) {
                            this.currentUserInput = userInput.substring(0, userInput.length - 1) + ":" + userInput.substring(userInput.length - 1, userInput.length);
                        }
                    }
                }
            },
            parseUserInput() {
                var userInput = this.currentUserInput;
                if (userInput != null) {
                    userInput = userInput.trim();
                    if (userInput.length > 0) {
                        var timeFormatRegex = new RegExp("^((?<hours>[0-2]?[0-9]):)??(?<minutes>[0-5]?[0-9])(:(?<seconds>[0-5]?[0-9]))?$");
                        var match = userInput.match(timeFormatRegex);
                        if (match) {
                            var seconds = 0;
                            if (match.groups.seconds) seconds += match.groups.seconds * 1;
                            if (match.groups.minutes) seconds += match.groups.minutes * 60;
                            if (match.groups.hours) seconds += match.groups.hours * 3600;
                            if (seconds != this.currentSeconds) {
                                this.currentSeconds = seconds;
                                this.$emit('change', this.currentSeconds);
                            }
                            this.formatSeconds();
                        } else {
                            if (this.currentSeconds != null) {
                                this.currentSeconds = null;
                                this.$emit('change', this.currentSeconds);
                            }
                            this.currentUserInput = null;
                            this.showErrorsToast(["Input is not in a valid format"]);
                        }
                    }
                }
                
            }
        },
        mounted() {
            this.formatSeconds();
        }
    }
</script>

<style scoped>
</style>
